// extracted by mini-css-extract-plugin
export var chevron = "_k1-2";
export var dropdownItems = "_k1-0";
export var item = "_k1-1";